import { BannerConfigurationFragment } from '@occc/graphql';

import {
  BannerId,
  GetBannerFromBannerListByIdProps,
  MapBannersIdsToAutocompleteOptionsProps,
  MapBannersIdsToBannerTitleListProps,
} from './types';

const DISPLAY_CATEGORY_BASE_URL = '/display-categories';

const getInputTestId = (inputName: string) => `display-category-form-field-${inputName}`;

export const routeCreator = {
  list: () => DISPLAY_CATEGORY_BASE_URL,
  update: (id: string) => `${DISPLAY_CATEGORY_BASE_URL}/${id}/update`,
  create: () => `${DISPLAY_CATEGORY_BASE_URL}/create`,
  details: (id: string) => `${DISPLAY_CATEGORY_BASE_URL}/${id}`,
};

export const testIdValues = {
  name: getInputTestId('name'),
  rank: getInputTestId('rank'),
  banners: getInputTestId('banners'),
};

export const getInputProps = (testId: string) => ({
  'data-testid': testId,
});

export const parseBannerIds = (banners?: BannerConfigurationFragment[]): BannerId[] => {
  return banners?.map((banner) => banner.uuid) || [];
};

export const getShouldLazyLoadBannersForMutation = (
  bannerIds: BannerId[],
  shouldLazyLoadBanners: boolean | undefined,
): boolean | null => {
  if (bannerIds.length === 0) {
    return null;
  }

  return shouldLazyLoadBanners ?? false;
};

export const getLoadingBehaviorLabel = (shouldLazyLoadBanners?: boolean | null): string =>
  shouldLazyLoadBanners ? 'Load On Entry' : 'Preload Offers';

export const getBannerFromBannerListById = ({
  bannerList,
  bannerId,
}: GetBannerFromBannerListByIdProps): BannerConfigurationFragment | null => {
  return (
    bannerList?.find((banner: BannerConfigurationFragment) => banner.uuid === bannerId) || null
  );
};

export const mapBannersIdsToAutocompleteOptions = ({
  bannerList,
  bannerIds,
}: MapBannersIdsToAutocompleteOptionsProps): BannerConfigurationFragment[] | undefined => {
  return bannerIds?.reduce((accumulator: BannerConfigurationFragment[], bannerId: BannerId) => {
    const banner = getBannerFromBannerListById({
      bannerId,
      bannerList,
    });

    if (!banner) {
      return accumulator;
    }

    return [...accumulator, banner];
  }, []);
};

export const mapBannersIdsToBannerTitleList = ({
  bannerList,
  selectedBannersIds,
}: MapBannersIdsToBannerTitleListProps): string | null => {
  return (
    selectedBannersIds
      ?.map(
        (bannerId: BannerId) =>
          getBannerFromBannerListById({
            bannerId,
            bannerList,
          })?.title,
      )
      ?.join(', ') || null
  );
};
